import "core-js/modules/es.string.trim-start.js";
import "core-js/modules/es.string.trim-end.js";

/*! Copyright (c) 2021-present the Core-fn authors. All rights reserved. MIT license. */
import { curry as t } from "curry-rice";
/*! Copyright (c) 2021-present the is-valid authors. All rights reserved. MIT license. */

var e = function e(t) {
  return function (e) {
    return typeof e === t;
  };
},
    r = e("undefined"),
    i = e("function"),
    n = function n(t) {
  return !!t;
},
    c = function c(t, e, r) {
  return (i(t) ? n(t()) : n(t)) ? i(e) ? e() : e : i(r) ? r() : r;
},
    o = function o(t, e) {
  try {
    return function (t) {
      return c(i(t), function () {
        return t();
      }, t);
    }(t);
  } catch (t) {
    return c(i(e), function () {
      return e(t);
    }, function () {
      return c(function (t) {
        return !t;
      }(r(e)), e, t);
    });
  }
},
    s = t(function (t, e, r) {
  return r.replace(t, e);
}),
    a = t(function (t, e) {
  return e.startsWith(t);
}),
    l = t(function (t, e) {
  return e.endsWith(t);
}),
    u = function u(t) {
  return t.trim();
},
    d = function d(t) {
  return t.trimStart();
},
    p = d,
    m = function m(t) {
  return t.trimEnd();
},
    h = m,
    f = function f(t) {
  return t.toLowerCase();
},
    g = function g(t) {
  return t.toUpperCase();
},
    y = t(function (t, e) {
  return o(function () {
    return e.repeat(t);
  }, "");
}),
    x = t(function (t, e) {
  return e.match(t);
}),
    C = t(function (t, e) {
  return e.charAt(t);
}),
    A = function A(t) {
  return t.length;
},
    W = t(function (t, e) {
  return e.includes(t);
}),
    b = t(function (t, e) {
  return e.map(t);
}),
    k = t(function (t, e, r) {
  return r.slice(null != t ? t : 0, e);
}),
    w = t(function (t, e) {
  return t.test(e);
}),
    E = t(function (t, e) {
  return t.exec(e);
}),
    I = function I(t) {
  return t.dotAll;
},
    L = function L(t) {
  return t.unicode;
},
    S = function S(t) {
  return t.ignoreCase;
},
    U = function U(t) {
  return t.flags;
},
    j = function j(t) {
  return t.global;
},
    q = function q(t) {
  return t.sticky;
},
    v = function v(t) {
  return t.multiline;
},
    z = function z(t) {
  return t.source;
},
    B = function B(t) {
  return t.lastIndex;
},
    D = function D(t) {
  return t.description;
};
/*! Copyright (c) 2021-present the Fonction authors. All rights reserved. MIT license. */


export { C as charAt, D as description, I as dotAll, l as endsWith, E as exec, U as flags, j as global, S as ignoreCase, W as includes, B as lastIndex, A as length, b as map, x as match, v as multiline, y as repeat, s as replace, k as slice, z as source, a as startsWith, q as sticky, w as test, f as toLowerCase, g as toUpperCase, u as trim, m as trimEnd, p as trimLeft, h as trimRight, d as trimStart, L as unicode };